import React from 'react';
import SarasTrans from '../../notifications/SarasTrans';

const SarasBoolPicker = ({ id, value, onChange, disabled, label = 'Value' }) => {
    const currentValue = String(value == null ? '' : value).trim().toLowerCase();

    return (
        <div id={id} className="uiFlexBox3" role="group" aria-label={label}>
            {[{ value: '1', label: 'Yes', aliases: ['1', 'true', 'yes'] },
              { value: '0', label: 'No', aliases: ['0', 'false', 'no'] }].map(option => {
                const selected = option.aliases.includes(currentValue);
                return (
                    <button key={option.value} type="button" disabled={disabled}
                        className={`uiTabButtonLook${selected ? ' uiTabActiveButtonLook' : ''}`}
                        aria-pressed={selected}
                        onClick={event => onChange(event, option.value)}>
                        <SarasTrans value={option.label} />
                    </button>
                );
            })}
        </div>
    );
};

export default SarasBoolPicker;
